var React = require('react');

function BreathCommentSliderPrevBtn (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M13.8644 0.61862L0.610031 14.06C-0.203325 14.8848 -0.203325 16.2221 0.610031 17.0469L13.8644 30.4883C14.6778 31.3131 15.9965 31.3131 16.8098 30.4883C17.6232 29.6634 17.6232 28.3261 16.8098 27.5013L5.02816 15.5534L16.8098 3.60558C17.6232 2.78076 17.6232 1.44345 16.8098 0.61862C15.9965 -0.206207 14.6778 -0.206207 13.8644 0.61862Z","fill":"white"}));
}

BreathCommentSliderPrevBtn.defaultProps = {"width":"18","height":"32","viewBox":"0 0 18 32","fill":"none"};

module.exports = BreathCommentSliderPrevBtn;

BreathCommentSliderPrevBtn.default = BreathCommentSliderPrevBtn;
